module.exports = "/_next/static/images/City girl-bro 2-3b805efa5e0a99e32367615db2e0591b.png";